export default {
  computed: {
    debug() {
      return process.env.VUE_APP_SHOW_DEBUG
    }
  }
}
